import React from 'react'
import Loading from '../../Component/Loading'
import { color } from '../../StyleData/Config'
import { Box, Typography } from '@mui/material'

const HSE = () => {
  return (
    <>
    <Box>
            <Typography
              sx={{
                color: color.masterPageTitleColor,
                fontSize: color.masterPageTitleFontSize,
                fontWeight: color.masterPageTitleFontWeight,
                mb: color.masterPageTitlemd,
              }}
            >
              HSE
            </Typography>
          </Box>
          <Loading/>
    </>
   
  )
}

export default HSE